import { render } from "./adminInvite.vue?vue&type=template&id=63989b34&scoped=true"
import script from "./adminInvite.vue?vue&type=script&lang=js"
export * from "./adminInvite.vue?vue&type=script&lang=js"

import "./adminInvite.vue?vue&type=style&index=0&id=63989b34&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63989b34"]])

export default __exports__